// Source/Bonus-Label/Component.ts
var Marker = "\uD83C\uDF81";
var Hub_Path = `/search`;
var Endpoint = `${Hub_Path}?q=${Marker}`;

class BonusLabel extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    this.dataset.isLoaded = String(false);
    const onOpen = this.onOpen.bind(this);
    this.addEventListener("click", onOpen, {
      signal
    });
    this.load();
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  onOpen() {
    this.dialog.showModal();
  }
  async load() {
    if (this.isLoaded)
      return;
    this.dataset.isLoaded = String(true);
    this.furnish();
  }
  async furnish() {
    const html = await this.fetch();
    this.innerHTML += html;
  }
  async fetch() {
    const parameters = new Map;
    parameters.set("Variant", this.dataset.variant);
    parameters.set("Handle", this.dataset.handle);
    const entries = Array.from(parameters.entries());
    const pairs = entries.map(([key, value]) => `${key}:${value}`).join(";");
    const payload = encodeURIComponent(pairs);
    const query = `${Endpoint}${payload}`;
    const url = new URL(query, location.href);
    return await fetch(url).then((response) => response.text());
  }
  get dialog() {
    return this.querySelector(`.Bonus-Popup-Dialog`);
  }
  get isLoaded() {
    return this.dataset.isLoaded === "true";
  }
}

// Source/Bonus-Label/mod.ts
customElements.define("bonus-label", BonusLabel);
